import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { useTicketByIdQuery, useTicketByQRCodeQuery } from '@/features/tickets/api/queries'
import { useImage } from '@/shared/composables/image'
import TicketAssignmentInterface from '@/features/tickets/ui/TicketAssignmentInterface.vue'
import AvatarPlaceholder from '@/features/tickets/assets/AvatarPlaceholder.vue'
import { ModalWrapper } from '@/shared/ui/modals'
import { useUserQuery } from '@/enitites/user/api/queries'
import { mdiClose } from '@mdi/js'
import SelectedTicketAdmin from '@/features/tickets/ui/SelectedTicketAdmin.vue'
import PurchaseReceipt from '@/features/tickets/ui/PurchaseReceipt.vue'
import RefundTicketInterface from '@/features/tickets/ui/RefundTicketInterface.vue'
import ChangeTierInterface from '@/features/tickets/ui/ChangeTierInterface.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminTicketModal',
  props: {
    ticketId: null,
    qrCode: null,
    value: { type: Boolean },
    eventId: null
  },
  emits: ["close-modal"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close-modal'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  ticketId?: number
  qrCode?: string
  value: boolean
  eventId: number
};





const { getImageById } = useImage()

const computedTicketId = computed(() => {
  return props.value && props.ticketId ? props.ticketId : undefined
})
const computedQRCode = computed(() => {
  return props.value && props.qrCode ? props.qrCode : undefined
})

const { data: ticketById, isLoading: isLoadingById, isError: isErrorById } = useTicketByIdQuery(computedTicketId)
const { data: ticketByQR, isLoading: isLoadingByQR, isError: isErrorByQR } = useTicketByQRCodeQuery(computedQRCode)

const ticket = computed(() => {
  if (props.ticketId) {
    return ticketById.value
  }
  if (props.qrCode) {
    return ticketByQR.value
  }
  return undefined
})

const computedAssignedUserId = computed(() => {
  return props.value && ticket.value?.assignedTo?.userId ? ticket.value.assignedTo.userId : undefined
})

const { data: userDetails, isLoading: isLoadingUserDetails } = useUserQuery(computedAssignedUserId)

const isLoading = computed(() => {
  if (props.ticketId) {
    return isLoadingById.value
  }
  if (props.qrCode) {
    return isLoadingByQR.value
  }
  return false
})

const isError = computed(() => {
  if (props.ticketId) {
    return isErrorById.value
  }
  if (props.qrCode) {
    return isErrorByQR.value
  }
  return false
})

const closeModal = (value: boolean) => {
  if (!value) {
    emit('close-modal')
  }
}

const getAgeByBirthdate = (birthdate: string): number => {
  const today = new Date()
  const birthDate = new Date(birthdate)
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDifference = today.getMonth() - birthDate.getMonth()
  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1
  }
  return age
}

const isShowAssignmentInterface = ref(false)
const isShowSuccessAssignmentMessage = ref(false)
const isShowChangeTierInterface = ref(false)
const isShowRefundInterface = ref(false)
const isShowReceiptInterface = ref(false)

return { __sfc: true,props, emit, getImageById, computedTicketId, computedQRCode, ticketById, isLoadingById, isErrorById, ticketByQR, isLoadingByQR, isErrorByQR, ticket, computedAssignedUserId, userDetails, isLoadingUserDetails, isLoading, isError, closeModal, getAgeByBirthdate, isShowAssignmentInterface, isShowSuccessAssignmentMessage, isShowChangeTierInterface, isShowRefundInterface, isShowReceiptInterface, TicketAssignmentInterface, AvatarPlaceholder, ModalWrapper, mdiClose, SelectedTicketAdmin, PurchaseReceipt, RefundTicketInterface, ChangeTierInterface }
}

})